// Version : 0.0.2
// Author : Nandhakumar
// LastAdd : 'Converted Existed Values for the Keys from Upper Case to Smaller Case'
// Modified Date : 4-12-2025

const GoldLoanCollectionActionTypes = {
	/** *****************GET GOLD LOAN INDEX DETAILS START *********************** */
	GET_GOLD_LOAN_INDEX_DETAILS_START: 'get_gold_loan_index_details_start',
	GET_GOLD_LOAN_INDEX_DETAILS_SUCCESS: 'get_gold_loan_index_details_success',
	GET_GOLD_LOAN_INDEX_DETAILS_FAILURE: 'get_gold_loan_index_details_failure',
	GET_GOLD_LOAN_INDEX_DETAILS_RESPONSE_RESET: 'get_gold_loan_index_details_response_reset',
	GET_GOLD_LOAN_INDEX_DETAILS_RESPONSE_CHANGED: 'get_gold_loan_index_details_response_changed',
	/** *****************GET GOLD LOAN INDEX DETAILS END *********************** */

	/** *****************GET GOLD LOAN INDEX INFO START *********************** */
	GET_GOLD_LOAN_INDEX_INFO_START: 'get_gold_loan_index_info_start',
	GET_GOLD_LOAN_INDEX_INFO_SUCCESS: 'get_gold_loan_index_info_success',
	GET_GOLD_LOAN_INDEX_INFO_FAILURE: 'get_gold_loan_index_info_failure',
	GET_GOLD_LOAN_INDEX_INFO_RESPONSE_RESET: 'get_gold_loan_index_info_response_reset',
	GET_GOLD_LOAN_INDEX_INFO_RESPONSE_CHANGED: 'get_gold_loan_index_info_response_changed',
	/** *****************GET GOLD LOAN INDEX INFO END *********************** */

	/** *****************DELETE GOLD LOAN INDEX START *********************** */
	DELETE_GOLD_LOAN_INDEX_START: 'delete_gold_loan_index_start',
	DELETE_GOLD_LOAN_INDEX_SUCCESS: 'delete_gold_loan_index_success',
	DELETE_GOLD_LOAN_INDEX_FAILURE: 'delete_gold_loan_index_failure',
	DELETE_GOLD_LOAN_INDEX_RESPONSE_RESET: 'delete_gold_loan_index_response_reset',
	DELETE_GOLD_LOAN_INDEX_RESPONSE_CHANGED: 'delete_gold_loan_index_response_changed',
	/** *****************DELETE GOLD LOAN INDEX END *********************** */

	/** *****************GET PARTICULAR GOLD LOAN INDEX INFO START *********************** */
	GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_START: 'get_particular_gold_loan_index_info_start',
	GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_SUCCESS: 'get_particular_gold_loan_index_info_success',
	GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_FAILURE: 'get_particular_gold_loan_index_info_failure',
	GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_RESPONSE_RESET:
		'get_particular_gold_loan_index_info_response_reset',
	GET_PARTICULAR_GOLD_LOAN_INDEX_INFO_RESPONSE_CHANGED:
		'get_particular_gold_loan_index_info_response_changed',
	/** *****************GET PARTICULAR GOLD LOAN INDEX INFO END *********************** */

	/** *****************UPDATE GOLD LOAN INDEX COLLECTION START *********************** */
	UPDATE_GOLD_LOAN_INDEX_COLLECTION_START: 'update_gold_loan_index_collection_start',
	UPDATE_GOLD_LOAN_INDEX_COLLECTION_SUCCESS: 'update_gold_loan_index_collection_success',
	UPDATE_GOLD_LOAN_INDEX_COLLECTION_FAILURE: 'update_gold_loan_index_collection_failure',
	UPDATE_GOLD_LOAN_INDEX_COLLECTION_RESPONSE_RESET:
		'update_gold_loan_index_collection_response_reset',
	UPDATE_GOLD_LOAN_INDEX_COLLECTION_RESPONSE_CHANGED:
		'update_gold_loan_index_collection_response_changed',
	/** *****************UPDATE GOLD LOAN INDEX COLLECTION END *********************** */

	/** *****************GET MEMBER GOLD LOAN COLLECTION DETAILS START *********************** */
	GET_MEMBER_GOLD_COLLECTION_DETAILS_START: 'get_member_gold_collection_details_start',
	GET_MEMBER_GOLD_COLLECTION_DETAILS_SUCCESS: 'get_member_gold_collection_details_success',
	GET_MEMBER_GOLD_COLLECTION_DETAILS_FAILURE: 'get_member_gold_collection_details_failure',
	GET_MEMBER_GOLD_COLLECTION_DETAILS_RESPONSE_RESET:
		'get_member_gold_collection_details_response_reset',
	GET_MEMBER_GOLD_COLLECTION_DETAILS_RESPONSE_CHANGED:
		'get_member_gold_collection_details_response_changed',
	/** *****************GET MEMBER GOLD LOAN COLLECTION DETAILS END *********************** */
};
export default GoldLoanCollectionActionTypes;
